export const closeProjectResponsibleFields = [
  { field: 'projectOwner', label: 'labels.projectOwner' },
  { field: 'projectOrderer', label: 'labels.projectOrderer' },
  {
    field: 'projectManager',
    label: 'labels.projectManager',
  },
];

export const defaultProjectResponsibleFields = [
  ...closeProjectResponsibleFields,
  { field: 'projectAdmin', label: 'labels.projectAdmin' },
  { field: 'clusterREManager', label: 'labels.clusterREManager' },
  { field: 'reDevLead', label: 'labels.reDevLead' },
  { field: 'planningLeader', label: 'labels.planningLeader' },
  { field: 'constructionManager', label: 'labels.constructionManager' },
  { field: 'digitalLeader', label: 'labels.digitalLeader' },
];

export const responsibleWithCountryResponsibleFields = [
  ...defaultProjectResponsibleFields,
];
